var exports = {};
exports.POSITION_AT_SHORTHAND = {
  first: 0,
  second: 1
};
export default exports;